import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  consoleLogLevel: NgxLoggerLevel.WARN,
  serverLogLevel: NgxLoggerLevel.WARN,
};
